const doc = [({"ja":({"adminConstantBookingPayType":({"creditCard":"クレジットカード決済", "onSite":"現地払い"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;